<template>

  <div class="d-flex d-inline rounded m-4 p-3 " @dragover.prevent @drop.prevent @drop="onFileChange"
       :style="errors.length > 0 ? 'border:dashed 2px red; background: #FFC3C6':'border:dashed 2px gray; background: #EEF0F8'">

    <v-flex md6 lg6 xl6 sm6 xs6 class="mt-2">
      <div class="w-100 text-center clickable">

        <v-img v-ripple @click="pick" id="avatar-block" class="rounded opacity-80"
               style="border: solid 1px gray; max-width: 250px; max-height: 169px"
               :aspect-ratio="1.5" :src="(image || '/media/img.webp')">

          <input type="file" class="d-none avatar" name="avatar" @change="onFileChange"></v-img>

      </div>
    </v-flex>
    <v-spacer/>

    <v-flex md5 lg5 xl5 sm5 xs5 class="">
      <v-row class="justify-content-end pl-1 pt-1">

        <v-btn @click="image = null, value = []" small icon>
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>
      </v-row>
      <div class="ml-3" style="max-height: 166px">

        <v-list-item style="margin-bottom: -20px">
          <v-list-item-content>
            <v-list-item-title>{{ title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <hr style="border: dashed 0.5px gray; margin-right: 15px">
        <v-list-item two-line style="margin-top: -20px; margin-bottom: -20px">
          <v-list-item-content>
            <v-list-item-title>اسم تصویر</v-list-item-title>
            <v-list-item-subtitle>{{ (value.name || 'انتخاب نشده!') }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <hr style="border: dashed 0.5px gray; margin-right: 15px">
        <v-list-item two-line style="margin-top: -20px; margin-bottom: -20px">
          <v-list-item-content>
            <v-list-item-title>حجم تصویر</v-list-item-title>
            <v-list-item-subtitle>{{ (getReadableFileSizeString(value.size)) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!--        <hr v-if="errorMessage!==null" style="border: dashed 0.5px gray; margin-right: 15px">-->
        <span v-if="errorMessage!==null"
              style="color: darkred; font-size: 11px; margin-right: 15px; padding-bottom: 10px">{{
            errorMessage
          }}</span>
      </div>
    </v-flex>
  </div>

</template>

<script>

export default {
  props: ['value', 'errors', 'dense', 'return_object', 'title'],

  data() {
    return {
      errorMessage: null,
      singleExpand: false,
      picture: [],
      image: null,
    }
  },
  created() {
  },
  computed: {},
  name: "siteSelect",
  methods: {
    getReadableFileSizeString(fileSizeInBytes) {
      if (!fileSizeInBytes)
        return 'ندارد!';
      let i = -1;
      let byteUnits = ['کیلو بایت', ' مگابایت', ' گیگابایت', ' ترابایت', 'PB', 'EB', 'ZB', 'YB'];
      do {
        fileSizeInBytes /= 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return this.persian(Math.max(fileSizeInBytes, 0.1).toFixed(1)) + " " + byteUnits[i];
    },

    pick(e) {
      if (e.path[0].children[0])
        e.path[0].children[0].click()
    },
    // picked(e) {
    //   let files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) return;
    //   if (files.length >= 1) {
    //     this.picture = files[0];
    //     let avatarBlock = document.getElementById("avatar-block");
    //     let fileReader = new FileReader();
    //     fileReader.onload = function (e) {
    //       let preview = avatarBlock.getElementsByClassName("v-image__image")[0]
    //       preview.style.backgroundImage = "url('" + this.result + "')";
    //       preview.style.display = "block";
    //     };
    //    return  fileReader.readAsDataURL(files[0]);
    //   }
    // },
    onFileChange(e) {

      const file = e.target.files || e.dataTransfer.files;
      this.value = file[0]

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.image = event.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit('changeValue', this.value)
      } else {
        alert("Sorry, FileReader API not supported");
      }
    }

  },
  watch: {
    value(val) {
      if (val.size > 2_097_152) {
        this.errorMessage = 'حجم فایل شما بیشتر از ۲ مگابایت می باشد.';
        return this.errors = [1]
      }
      this.errorMessage = null;
      this.errors = []
      this.$emit('changeValue', this.value)
    },
  }
}
</script>

<style scoped>

</style>